import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
import md5 from 'md5';
class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      categorylist: [],
      rewardlist: [],
      activePage: 1,
      pagecount: 1,
      products_page_count: 1,
      isActive: false,
      activeTab: 1,
      formData: {}, // Contains login form data
      errors: {}, // Contains login field errors
      formSubmitted: false, // Indicates submit status of login form
      loading: true, // Indicates in progress state of login form
      tblprofile: [],
      userid: null,
      modalx: false,
      modal: false,
      linkaff: "",
      point: 0,
      useradvice: [],
      balance: 0,
      loginstate: null,
      firstname: null,
      lastname: null,
      alert: null,
      modalOpen: false,
      handleClose: false,
      proderedeemlist: [],
      token: window.localStorage.getItem("token"),
      type: "",
      username: "",
      amount: "",
      remark: "",
      mainacc: "",
      rankpic: "1.jpeg",
      rankname: null,
      rankob: null,
      rankpoint: 0,
      name: "",
      password: "",
      left: false,
      pathname: "",
      linelink: ""
    }
  }
  async componentDidMount() {
    await instance.post("/api/v1/mainsetting", {
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        const datas = res.data.message;
        this.setState({
          linelink: datas[1].value,
        });
      }
      else {
        // this.CheckThisGoalError();
      }
    });
    var userAgent = navigator.userAgent.toLowerCase()

    try {
      var token = localStorage.getItem('auth_token');
      //  //////console.log(token);
      if (token != null) {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await this.rechecklogin(Username, token);
        this.setState({
          userid: decoded.message.playerid,
          username: decoded.message.playerid,
          firstname: decoded.message.firstname,
          lastname: decoded.message.lastname,
          loginstate: true,
        });
      }
      else {
        this.setState({
          loginstate: false,
        });
      }
    }
    catch (error) {
      //////console.log();
    }

  }
  logout = (e) => {

    // window.location.href = '/logout';

  }
  async componentDidMount() {
    await instance.post("/api/v1/mainsetting", {
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        const datas = res.data.message;
        this.setState({
          linelink: datas[1].value,
        });
      }
      else {
        // this.CheckThisGoalError();
      }
    });
    var userAgent = navigator.userAgent.toLowerCase()
    // if (userAgent.indexOf('safari') != -1) {
    //     if (userAgent.indexOf('chrome') > -1) {
    //     } else {
    //         await Swal.fire({
    //             title: 'Warning!',
    //             text: 'แนะนำให้ใช้งานบน Google Chorme เพื่อประสิทธิภาพที่ดีกว่า',
    //             icon: 'warning',
    //             confirmButtonText: 'ตกลง'
    //         })
    //     }
    // }

    try {
      var token = localStorage.getItem('auth_token');
      //  //////console.log(token);
      if (token != null) {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await this.rechecklogin(Username, token);
        this.setState({
          userid: decoded.message.playerid,
          username: decoded.message.playerid,
          firstname: decoded.message.firstname,
          lastname: decoded.message.lastname,
          loginstate: true,
        });
      }
      else {
        this.setState({
          loginstate: false,
        });
      }
    }
    catch (error) {
      //////console.log();
    }

  }
  openAccout(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].className += " -open";
    }
  }
  async checkuseradvice() {
    instance.post("/api/v1/checkuseradvice", {
      User_id: this.state.username,
      page: 1,
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        console.log(res.data.message.useradvicelist);
        this.setState({
          useradvice: res.data.message.useradvicelist
        });
      }
      else {
        // console.log(res.data);
        // this.CheckThisGoalError();
      }
    });
  }

  cancelredeempromotion = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: 'คุณต้องการยกเลิกการใช้โปรใช่ หรือ ไม่?',
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/usercancelpromotion", {
            User_id: Username,
            System: Systems,
            no: index.no,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.checkpro(null, 999);
              Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
            }
            else {
              Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
            }
          });

        }
      })
    }

  }

  openAccoutcan(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].className = "x-menu-account-list-sidebar";
    }
  }

  async rechecklogin(Username, token) {

    try {
      // console.log(4);
      const search = window.location.href;
      const paramx = new URLSearchParams(search);
      // const space = search.split("/")
      const space = window.location.host
      var userhash = md5(Username);
      //  const linkaff = "https://pgline88.com/?register=" + userhash;
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'rechecklogin-sidebar.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        //  console.log(res.data);
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            rankpic: res.data.tblrank.image,
            rankname: res.data.tblrank.name,
            linkaff: linkaff,
            rankob: res.data.tblrank,
            rankpoint: res.data.rankpoint,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            tblprofile: res.data.message,
            username: res.data.message.playerid,
            fname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        console.log(err)
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
      //////console.log(ex);
    }

  }
  checkpro = async (e, proid) => {
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/checkpromotion", {
      userid: Username,
      System: Systems,
      Proid: proid,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        //console.log(res.data)
        // console.log(res.data.message.tblpromotionredeems)
        if (res.data.type === 0) {
          this.setState({
            prodetail: res.data.message.tblpromotions,
          });
        }
        else if (res.data.type === 1) {
          this.setState({
            proderedeemlist: res.data.message.tblpromotionredeems,
          });

        }

      }
      else if (res.data.status === 201) {
        await Swal.fire({
          title: 'error!',
          text: 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        return false;
      }
      else if (res.data.status === 202) {
        await Swal.fire({
          title: 'error!',
          text: 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        return false;
      }

    }).catch(async (err) => {
      // console.log(err);
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
        window.location.href = '/';
      }
    });
  }


  validateLogout = (e) => {
    localStorage.removeItem('auth_token', '')
    this.setState({
      userid: null,
      username: null,
      password: null,
      firstname: null,
      lastname: null,
      point: null,
      loginstate: false,
    });
  }
  async recheccredit(evt) {

    evt.currentTarget.className += " fa-spin";
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    //  this.rechecklogin(Username, token);
    this.setState({
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      firstname: decoded.message.firstname,
      lastname: decoded.message.lastname,
      loginstate: true,
    });
    try {
      //  console.log(5);
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-navbar.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        //console.log(res.data);
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
          var i, tablinks;
          tablinks = document.getElementsByClassName("-btn-balance");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
          }
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          //   console.log(res.data);
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        //    console.log(err);
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
      //////console.log(ex);
    }
  }

  logout = (e) => {
    // e.preventDefault();
    let errors = this.validateLogout();
    if (errors === true) {
      // alert("You are successfully signed in...");
      window.location.reload()
    } else {

      this.setState({
        errors: errors,
        formSubmitted: true
      });
      window.location.reload()
    }
  }

  render() {
    const pathname = this.state.pathname
    const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
    return (
      <>
        <div className="container-fluid align-items-center h-100 position-relative">
          <div id="headerBrand">
            <a
              onClick={(e) => {
                this.setState({
                  modalx: true
                });
              }}
              className="btn navbar-brand"
              style={{
                cursor: "pointer",
                width: 20,
                color: "rgba(95, 117, 223, 0) !important"
              }}
            >
              <div
                onClick={(e) => {
                  this.setState({
                    modalx: true
                  });
                }}
                role="button"
                className="menu_icon"
                style={{ top: "-25px", left: "-15px" }}
              >
                <span className="one" />
                <span className="two" />
                <span className="three" />
              </div>
            </a>
            <div className="-branding-inner-wrapper">
              {/**/}
              <a className="navbar-brand text-white-v1" href="/" role="button">
                <img
                  src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                  className="w-logo-web-w-v147"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div id="headerContent">
            <ul className="nav -menu-wrapper -logged">
              <li className="nav-item">
                <a
                  href="/refer/overview"
                  className="nav-link -promotion"
                  target="_self"
                >
                  <div className="-img-wrapper p-3">
                    <img
                      src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b484701-23cf-4a1e-a37b-251dd801a000/public"
                      className="-icon img-menu-navbar"
                      alt="Menu icon promotion"
                    />
                  </div>
                  <div className="-text">เเนะนำเพื่อน</div>
                </a>
              </li>
              <li className="nav-item">
                <a href="/loss" className="nav-link -promotion" target="_self">
                  <div className="-img-wrapper p-3">
                    <img
                      src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d19594c3-f5b7-4544-ce8c-b923b8f13200/public"
                      className="-icon img-menu-navbar"
                      alt="Menu icon promotion"
                    />
                  </div>
                  <div className="-text">คืนยอดเสีย</div>
                </a>
              </li>
              <li className="nav-item">
                <a href="/event" className="nav-link -promotion" target="_self">
                  <div className="-img-wrapper p-3">
                    <img
                      src="https://imagedelivery.net/OxMo058wRPZzbWHctmHqkA/14b1a3cf-e250-4d31-7541-cd39f837d300/public"
                      className="-icon"
                      alt="Menu icon promotion"
                      width={35}
                      height={35}
                    />
                  </div>
                  <div className="-text">กิจกรรม</div>
                </a>
              </li>
              <li className="nav-item">
                <a href="/promotion" className="nav-link -promotion" target="_self">
                  <div className="-img-wrapper p-3">
                    <img
                      src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/907ff1f1-3e6d-4cfc-c89b-1cd216488900/public"
                      className="-icon img-menu-navbar"
                      alt="Menu icon promotion"
                    />
                  </div>
                  <div className="-text">โปรโมชั่น</div>
                </a>
              </li>
            </ul>
            <div className="navbar-nav">
              {(loginstate != null) ? (!loginstate) ?
                <div className="x-logged">
                  <div className="-profile-container">
                    <div>
                      <div className="d-flex">
                        <a href='/signin'>
                          <div className="flex-fill m-1" >
                            <span className="login-auth p-2 pl-2-1 v-login">
                              <b>เข้าสู่ระบบ</b>
                            </span>
                          </div>
                        </a>
                        <div className="flex-fill m-1">

                          <a href='/register'>
                            <span className="register-auth p-2 pl-2-1 v-register">
                              <b>สมัครสมาชิก</b>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                : <div className="x-logged">
                  <div className="-deposit-container d-none d-lg-block">
                    <a
                      href="/deposit"
                      className="text-white-v1 js-account-approve-aware btn -btn-deposit"
                    >
                      <div className="f-7">ฝากเงิน</div>
                    </a>
                  </div>
                  <div className="-withdraw-container d-none d-lg-block">
                    <a
                      href="/withdraw"
                      className="text-white-v1 js-account-approve-aware btn -btn-withdraw"
                    >
                      <div className="f-7">ถอนเงิน</div>
                    </a>
                  </div>
                  <div className="-profile-container">
                    <div className="d-none d-lg-block">
                      <div className="-btn-wrapper">
                        <div className="-inner-wrapper">
                          <div className="-balance-container">
                            <div className="-text-username11 pl-2">{username}</div> &nbsp;
                            &nbsp; &nbsp;{" "}
                            <div className="-user-balance js-user-balance f-sm-6 f-7">
                              <div className="-inner-box-wrapper">
                                <img
                                  className="img-fluid -ic-coin"
                                  src="https://play.mm88big.com/assets/ic-coin.daf5aefd.png"
                                  alt="customer image"
                                  width={26}
                                  height={21}
                                />
                                <span id="customer-balance" className="js-customer-balance">
                                  <span className="-amount"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /> {/**/}</span>
                                </span>{" "}
                                &nbsp; {/**/} &nbsp;{" "}
                                {/* <a role="button" id="icon-refresh-credit" className="mt-2 mb-2">
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={15}
                                      height={15}
                                      fill="currentColor"
                                      className="bi bi-arrow-clockwise text-white-v1"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                      />
                                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                    </svg>
                                  </span>
                                </a> */}
                              </div>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.recheccredit(e)
                              }}
                                id="btn-customer-balance-reload"
                                className="-btn-balance"
                              >
                                <i className="fas fa-sync-alt" />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="x-profile-image">
                          <img
                            role="button"
                            onClick={(e) => {
                              this.setState({
                                modal: true
                              });
                            }}
                            className="img-fluid -profile-image"
                            src={"/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png" }
                            alt="customer image"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-lg-none">
                      <div className="js-ez-logged-sidebar -btn-mobile-wrapper">
                        <div className="-inner-wrapper">
                          <div className="-balance-container">
                            <div className="-text-username">{username}</div>
                            <div className="-user-balance js-user-balance f-sm-6 f-7">
                              <div className="-inner-box-wrapper">
                                <img
                                  className="img-fluid -ic-coin"
                                  role="button"
                                  src="/assets/ic-coin.daf5aefd.png"
                                  alt="customer image"
                                  width={26}
                                  height={21}
                                />
                                <span id="customer-balance" className="js-customer-balance">
                                  <span className="-amount"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} />  {/**/}</span> &nbsp;{" "}
                                  <a role="button"
                                    onClick={(e) => {
                                      this.recheccredit(e)
                                    }}
                                    className="-btn-balance"
                                    data-target="#customer-balance"
                                    id="icon-refresh-credit">
                                    <span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={15}
                                        height={15}
                                        fill="currentColor"
                                        className="bi bi-arrow-clockwise text-white-v1-web"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                        />
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                      </svg>
                                    </span>
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x-profile-image">
                          <img
                            onClick={(e) => {
                              this.setState({
                                modal: true
                              });
                            }}
                            role="button"
                            className="img-fluid -profile-image"
                            src={"/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png" }
                            alt="customer image"
                          />
                        </div>
                      </div>
                      <div className="x-menu-account-list-sidebar -open">
                        <div className="x-modal-account-menu-mobile">
                          <div className="-modal-profile-mobile d-xl-none d-block">
                            <div className="text-right">
                              <i className="fas fa-times f-5 js-close-account-sidebar" />
                            </div>
                            <div className="x-profile-image">
                              <img
                                role="button"
                                onClick={(e) => {
                                  this.setState({
                                    modal: true
                                  });
                                }}
                                className="img-fluid -profile-image"
                                src={"/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png" }
                                alt="customer image"
                              />
                            </div>
                            <div className="-balance-container">
                              <div className="-text-username">{username}</div>
                              <div className="-user-balance js-user-balance f-sm-6 f-7">
                                <div className="-inner-box-wrapper">
                                  <img
                                    className="img-fluid -ic-coin"
                                    src="data:image/png;base64,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"
                                    alt="customer image"
                                    width={26}
                                    height={21}
                                  />
                                  <span id="customer-balance" className="js-customer-balance">
                                    <span className="-amount"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /> </span>
                                  </span>
                                </div>
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    this.recheccredit(e)
                                }}
                                  id="btn-customer-balance-reload"
                                  className="-btn-balance"
                                  data-loading="_onReloadBalance_"
                                  data-done="_onReloadBalanceDone_"
                                >
                                  <i className="fas fa-sync-alt f-9" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="-overlay" />
                      </div>
                    </div>
                  </div>
                </div>
                : ""}
            </div>
          </div>
        </div>


      </>
    );
  }
}
export default Main;

